<template>
  <div class="c-entrepreneur-parallax-large" :class="{ '-natural': natural }">
    <div class="c-entrepreneur-parallax-large__img">
      <asset :image="data.large_image" :cover="!natural" />
    </div>
  </div>
</template>

<script>
import Variables from "src/mixins/variables";
import Asset from "objects/Asset";
import gsap from "gsap";
export default {
  components: {
    Asset
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    natural: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    x(x) {
      gsap.to(this.$el, {
        duration: 0.2,
        x: x,
        ease: "sine.out"
      });
    },
    y(y) {
      gsap.to(this.$el, {
        duration: 0.2,
        y: y,
        ease: "sine.out"
      });
    },
    isHorizontal(horizontal) {
      if (horizontal) {
        this.y = 0;
      } else {
        this.x = 0;
      }
    }
  },
  mixins: [Variables],
  data() {
    return {
      x: 0,
      y: 0
    };
  },

  methods: {
    viewParallax(e) {
      if (this.isHorizontal) {
        this.x = ((e.percent.center.x - 0.75) * this.W.w) / 10;
      } else {
        this.y = ((e.percent.center.y - 0.5) * this.W.h) / 15;
      }
    }
  }
};
</script>

<style lang="scss">
.c-entrepreneur-parallax-large {
  display: flex;
  height: 100%;
  flex: 1;
  position: relative;
  max-width: 740px;

  margin-top: -25%;
  @media #{$breakpoint-horizontal} {
    margin-top: 0%;
  }
  &__img {
    z-index: 1;
  }

  /* asset component */
  .o-asset {
    min-height: 100vh;
  }
  .o-asset__img {
    min-height: 100vh;
  }

  &.-natural {
    max-width: none;
    flex: 0 0 auto;
    width: 100%;
    margin-top: 0;

    .o-asset {
      min-height: 0;
      background-color: transparent;
    }

    .o-asset__img {
      min-height: 0;
      width: 100%;
      height: auto;
      object-fit: contain;
      object-position: center center;
    }

    @media #{$breakpoint-horizontal} {
      width: max-content;
      height: 100%;

      .o-asset,
      .o-asset__img {
        width: auto;
        height: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>
